var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yanchu_goods_list_inner" },
    [
      _vm.goodsList && _vm.goodsList.length > 0
        ? [
            _vm.value.config.extend_sort === 1
              ? _c(
                  "div",
                  { staticClass: "navbar" },
                  _vm._l(_vm.navbarList, function (nav, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "nav-item",
                          index === _vm.activeNav && "current",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeNav(index)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(nav.label) + " "),
                        nav.icon
                          ? _c("i", { class: ["el-icon", nav.icon] })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.value.config.show_type === 2
              ? _c(
                  "div",
                  { staticClass: "box2" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "item-right" }, [
                        _c("div", { staticClass: "title u-line-2" }, [
                          _vm._v(" " + _vm._s(item.goods_name) + " "),
                        ]),
                        _c("div", { staticClass: "time" }, [
                          _vm._v(
                            " " +
                              _vm._s(item.show_start_time) +
                              " - " +
                              _vm._s(item.show_end_time) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "time city_name" }, [
                          _vm._v(
                            " " +
                              _vm._s(item.city_name) +
                              " | " +
                              _vm._s(item.venue_name) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "item__type" }, [
                          _vm._v(_vm._s(item.classify_name)),
                        ]),
                        _c("div", { staticClass: "price-box" }, [
                          item.shop_price
                            ? _c("div", { staticClass: "item__price" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("moneyFormat")(item.shop_price)
                                    )
                                ),
                                _c("span", { staticClass: "dianshu" }, [
                                  _vm._v("点起"),
                                ]),
                              ])
                            : _vm._e(),
                          item.ori_min_price
                            ? _c("div", { staticClass: "line-price" }, [
                                _vm._v(
                                  " " + _vm._s(item.ori_min_price) + "点 "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "distance" }, [
                        _vm._v(_vm._s(item.distance) + "km"),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm.value.config.show_type === 1
              ? _c(
                  "div",
                  { staticClass: "box" },
                  _vm._l(_vm.goodsList, function (item, index) {
                    return _c("div", { key: index, staticClass: "item" }, [
                      _c("div", {
                        staticClass: "pic",
                        style: {
                          backgroundImage: "url(" + item.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "title u-line-2" }, [
                        _vm._v(" " + _vm._s(item.goods_name) + " "),
                      ]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.show_start_time) +
                            " - " +
                            _vm._s(item.show_end_time) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "time city_name" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.city_name) +
                            " | " +
                            _vm._s(item.venue_name) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "item__type" }, [
                        _vm._v(_vm._s(item.classify_name)),
                      ]),
                      _c("div", { staticClass: "price-box" }, [
                        item.shop_price
                          ? _c("div", { staticClass: "item__price" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("moneyFormat")(item.shop_price))
                              ),
                              _c("span", { staticClass: "dianshu" }, [
                                _vm._v("点起"),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "distance" }, [
                          _vm._v(_vm._s(item.distance) + "km"),
                        ]),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]
        : _c("empty", { attrs: { value: _vm.value } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }